import { clientDb } from '../../../shared/firebase'
import { makeAudit } from '../../../shared/helpers'
import { UserAuth } from '../../../shared/interfaces'
import { ISafetyTeamRecord } from './types'

export const addSafetyTeamRecord = (user: UserAuth) => async (record: ISafetyTeamRecord) => {
  try {
    await clientDb().update(
      makeAudit(user, {
        [`safety-team/${record.id}`]: {
          ...record,
          createdAt: new Date().toISOString(),
        },
      })
    );
  } catch (error) {
    console.error('Error adding safety team record:', error);
  }
};

export const updateSafetyTeamRecord =
  (user: UserAuth) => async (recordId: string, updates: Partial<ISafetyTeamRecord>) => {
    try {
      await clientDb().update(
        makeAudit(user, {
          [`safety-team/${recordId}`]: {
            ...updates,
            updatedAt: new Date().toISOString(),
          },
        })
      );
    } catch (error) {
      console.error('Error updating safety team record:', error);
    }
  };

export const deleteSafetyTeamRecord = (user: UserAuth) => async (recordId: string) => {
  try {
    await clientDb().update(
      makeAudit(user, {
        [`safety-team/${recordId}`]: null,
      })
    );
  } catch (error) {
    console.error('Error deleting safety team record:', error);
  }
};

export const getSafetyTeamRecords = async (): Promise<Record<string, ISafetyTeamRecord>> => {
  const snapshot = await clientDb().child('safety-team').once('value')
  return snapshot.val() || {}
}
